/** @jsx jsx */

import React, { Fragment as _, useState, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import isIE from 'services/isIE';
import getBlockById from 'services/apiHelpers/getBlockById';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const IELayout = interactionContext => {
  return isIE()
    ? {
        Row: ({ children, ...props }) => {
          // console.clear();
          // console.log('IELayout ROW');

          const context = useContext(interactionContext);

          return (
            <div
              css={css`
                display: flex;
              `}
            >
              {children}
            </div>
          );
        },
        Column: ({ children, ...props }) => {
          const context = useContext(interactionContext);

          const testBorder = children.length === 1 ? 'lightBlue' : 'lime';

          const block = getBlockById(props.id);
          const isButtonBlock =
            block && block.meta && block.meta.subType === 'ButtonBlock';

          return (
            <div
              css={css`
            display: flex;
            ${isButtonBlock &&
              `
              justify-content: center;
              flex-wrap: wrap;
              `}
            align-items: center;
            width: 100%;
            // border: 1px solid ${testBorder};
           
            padding: 8px;
            

          `}
            >
              {children}
            </div>
          );
        },
        TwoColumnLayout: ({ children, ...props }) => {
          const context = useContext(interactionContext);
          return (
            <div
              css={css`
                display: flex;

                // word-break: break-all;
                // overflow-wrap: break-word;
                // white-space: pre-wrap;

                * {
                  // word-break: break-all;
                  // overflow-wrap: break-word;
                  // white-space: pre-wrap;
                }
              `}
            >
              {children}
            </div>
          );
        },
        SingleColumnLayout: ({ children, ...props }) => {
          const context = useContext(interactionContext);
          // console.log(children);
          return (
            <div
              css={css`
                display: flex;
                flex-direction: column;
                // flex: 0;
                width: 100%;

                ${children.length > 1 && 'height: auto;'}

                // word-break: break-all;
                // overflow-wrap: break-word;
                // white-space: pre-wrap;

                * {
                  // word-break: break-all;
                  // overflow-wrap: break-word;
                  // white-space: pre-wrap;
                }

                .chameleon-text {
                  width: 100%;

                  * {
                    width: 100%;
                  }
                }
              `}
            >
              {children}
            </div>
          );
        },
      }
    : {};
};

export default IELayout;
